import { Trans } from 'react-i18next';
import { legalConfig } from '../config/legal';

const linkClass = 'fo-link';

export function LegalTermsLabel() {
  return (
    <Trans
      i18nKey="legal.consent.acceptTerms"
      components={{
        termsLink: <a href={legalConfig.termsUrl} target="_blank" rel="noopener noreferrer" className={linkClass} />,
        required: <span className="text-red-500" />,
      }}
    />
  );
}

export function LegalPrivacyLabel() {
  return (
    <Trans
      i18nKey="legal.consent.acceptPrivacy"
      components={{
        privacyLink: <a href={legalConfig.privacyPolicyUrl} target="_blank" rel="noopener noreferrer" className={linkClass} />,
        required: <span className="text-red-500" />,
      }}
    />
  );
}
